
export const VERSION = '5.8.5'; // Update this manually on each release


